// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "/assets/index." + "46501bbdb9139dc7ef59" + ".js";
};